"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CHEMKIT_REVIEW_EXTENSION_VERSION = void 0;
exports.CHEMKIT_REVIEW_EXTENSION_VERSION = 2;
